import { render, staticRenderFns } from "./DoubleSideRectangularTrapezoidVertical.vue?vue&type=template&id=50aeeb9c&scoped=true&"
import script from "./DoubleSideRectangularTrapezoidVertical.vue?vue&type=script&lang=js&"
export * from "./DoubleSideRectangularTrapezoidVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aeeb9c",
  null
  
)

export default component.exports